const SystemCombinations = {
    title: 'Example JSON for system combinations helper parameters',
    initialDisplayedCode: `{
        "selectedOutcomes":[{
            "id": 1234,
            "odds": 1900,
            "startingPrice": false
        }, {
            "id": 45678,
            "odds": 2000
        }, {
            "id": 897,
            "odds": 1400
        }],
        "betErrorsIndexes":[],
        "translations":{
            "startingPrice":"SP",
            "totalOddsNotAvailable":"N/A"
        }
    }`,
};

export default SystemCombinations;
